var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCertificates = props => /*#__PURE__*/React.createElement("svg", _extends({
  color: "#0C9",
  width: 21,
  height: 35,
  viewBox: "0 0 21 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.634 11.407v12.986a2.734 2.734 0 0 1-2.734 2.734V25.76a1.367 1.367 0 0 0 1.367-1.367V11.407h-2.734l-.076-.001a8.045 8.045 0 0 0-1.973-1.974l-.001-.075V6.623H5.965A1.367 1.367 0 0 0 4.598 7.99H3.23a2.734 2.734 0 0 1 2.734-2.734h7.518l6.15 6.151Z",
  fill: "currentcolor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 18.726a.684.684 0 0 0-.968-.968l-3.617 3.618-1.567-1.568a.684.684 0 1 0-.967.968l2.05 2.05a.682.682 0 0 0 .968 0l4.1-4.1Z",
  fill: "currentcolor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9 27.127V14.141l-6.151-6.15H3.23a2.734 2.734 0 0 0-2.734 2.733v16.403a2.734 2.734 0 0 0 2.734 2.734h10.935a2.734 2.734 0 0 0 2.734-2.734Zm-6.151-15.036a2.05 2.05 0 0 0 2.05 2.05h2.734v12.986a1.367 1.367 0 0 1-1.367 1.367H3.231a1.367 1.367 0 0 1-1.367-1.367V10.724A1.367 1.367 0 0 1 3.23 9.357h7.518v2.734Z",
  fill: "currentcolor"
})));
export default SvgCertificates;